
class ProductGridNoResults extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.email = this.querySelector('[type="email"]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.valid = false;
    }
    onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.validateEmail(this.email.value)) {
            this.valid = true;
        }

        if (this.valid) {
            this.submitButton.classList.add('loading');
            this.email.classList.remove('error');

            let requestData = {
                type: 'post',
                data: {
                    TextToMatch: document.querySelector(`[data-live-search-input]`).value,
                    Type: "InStock",
                    Email: this.email.value
                }
            };

            let CurrentSubscriptionRecord = {};

            requestData.url = `${serverBaseUrl}/subscriptions`;

            $.ajax(requestData).then(function (response) {
                CurrentSubscriptionRecord = response.data || {};
            }).catch(function (err) {
                if (err.responseJSON.errorMessageData.subscriptionID) {
                    CurrentSubscriptionRecord = { _id: err.responseJSON.errorMessageData.subscriptionID };
                    requestData.url = `${serverBaseUrl}/update-subscription-status/` + encodeURIComponent(CurrentSubscriptionRecord._id);
                    requestData.type = 'patch';
                    requestData.data.Deleted = 'false';

                    $.ajax(requestData);
                }
            });
            this.form.classList.add('success');
            this.submitButton.classList.remove('loading');
        } else {
            this.email.classList.add('error');
        }

    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}

customElements.define('productgrid--no-results', ProductGridNoResults);



class ProductGridResults extends HTMLElement {
    constructor() {
        super();

        this.shopifyCustomerId = this.dataset.customerId;
        this.notifySubmitButton = document.querySelector('#start7');
        this.textToMatch = this.querySelector(`.toggle-button`).dataset.searchterm;

        this.toggleCheckbox = this.querySelector('[type="checkbox"]');
        this.toggleCheckbox.addEventListener('change', this.changeToggleButton.bind(this));
    }

    changeToggleButton(evt) {
        const checked = evt.target.checked || false;
        const textToMatch = document.querySelector(`.toggle-button`).dataset.searchterm;
        if (!textToMatch) {
            return;
        }

        if (this.shopifyCustomerId) {
            let requestData = {
                type: 'post',
                data: {
                    TextToMatch: textToMatch,
                    "Type": "InStock",
                    ShopifyCustomerID: this.shopifyCustomerId
                },
                success: function (response) {
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                }
            }

            if (checked) { /* subscribe */
                requestData.url = serverBaseUrl + '/subscriptions';

                $.ajax(requestData).then(function (response) {
                    CurrentSubscriptionRecord = response.data || {};
                }).catch(function (err) {
                    if (err.responseJSON.errorMessageData.subscriptionID) {
                        /* if subscription already exists */
                        CurrentSubscriptionRecord = { _id: err.responseJSON.errorMessageData.subscriptionID };
                        requestData.url = serverBaseUrl + '/update-subscription-status/' + encodeURIComponent(CurrentSubscriptionRecord._id);
                        requestData.type = 'patch';
                        requestData.data.Deleted = 'false';

                        $.ajax(requestData).then(function (response) {
                        });
                    }
                });
            } else { /* unsubscribe*/
                requestData.url = serverBaseUrl + '/update-subscription-status/' + encodeURIComponent(CurrentSubscriptionRecord._id);
                requestData.type = 'patch';
                requestData.data.Deleted = 'true';

                $.ajax(requestData).then(function (response) {
                    const toggleSubscriptionLabels = $('.toggle-button[data-searchterm="' + textToMatch + '"] .toggle-button-label');

                    $(".toggle-button .toggle-button-label").html("Notify me when   &#8220;" + textToMatch + "&#8221; is in stock");
                });
            }
        } else {
            if (checked) { /* subscribe */
                this.popupNotifySubscription(evt);
            } else { /* unsubscribe*/
                const userEmail = Cookies.get('user_email') || false;
                if (userEmail) {
                    const requestData = {
                        type: 'patch',
                        url: serverBaseUrl + '/update-subscription-status/' + encodeURIComponent(CurrentSubscriptionRecord._id),
                        data: {
                            TextToMatch: textToMatch,
                            Type: "InStock",
                            Email: userEmail,
                            Deleted: 'true'
                        },
                        success: function (response) {
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                        }
                    }

                    $.ajax(requestData).then(function (response) {
                        const toggleSubscriptionLabels = $('.toggle-button[data-searchterm="' + textToMatch + '"] .toggle-button-label');
                        $(".toggle-button .toggle-button-label").html("Notify me when   &#8220;" + textToMatch + "&#8221; is in stock");
                    });
                }
            }
        }
    }

    popupNotifySubscription(e) {
        e.preventDefault();

        const userEmail = Cookies.get('user_email') || false;

        $('#subscribe_text').text($('[data-live-search-input]').val());

        $.magnificPopup.open({
            items: {
                src: '#welcome_form7',
                type: 'inline',
                fixedContentPos: true,
                preloader: false,
                modal: true
            }
        });

        if (userEmail) {
            $('#email7').val(userEmail);
            $('#email7').addClass('form-field-filled');
        }

        this.notifySubmitButton.addEventListener('click', this.notifyFormSubmit.bind(this))
    }

    notifyFormSubmit(e) {
        e.preventDefault();

        const textToMatch = $('#subscribe_text').text();
        let errors = false;
        const user_email = $('#email7').val();

        if (!textToMatch) {
            $.magnificPopup.close();

            return;
        }

        if (!validateEmail(user_email)) {
            $('#email7').parents('.form-field').addClass('error');
            errors = true;
        } else {
            $('#email7').removeClass('form-field-error').parents('.form-field').removeClass('error');
        }

        if (!errors) {
            Cookies.set('user_email', user_email, { expires: 365, path: '/' });

            let requestData = {
                type: 'post',
                data: {
                    TextToMatch: textToMatch,
                    Type: "InStock",
                    Email: user_email
                },
                success: function (response) {
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                }
            }

            requestData.url = serverBaseUrl + '/subscriptions';

            $.ajax(requestData).then(function (response) {
                CurrentSubscriptionRecord = response.data || {};
            }).catch(function (err) {
                if (err.responseJSON.errorMessageData.subscriptionID) {
                    /* if subscription already exists */
                    CurrentSubscriptionRecord = { _id: err.responseJSON.errorMessageData.subscriptionID };
                    requestData.url = serverBaseUrl + '/update-subscription-status/' + encodeURIComponent(CurrentSubscriptionRecord._id);
                    requestData.type = 'patch';
                    requestData.data.Deleted = 'false';

                    $.ajax(requestData).then(function (response) {
                    });
                }
            });

            $.magnificPopup.close();
        }
    }
}

customElements.define('productgrid--results', ProductGridResults);